/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Hero_CaptionInputs */

const en_fc_home_hero_caption = /** @type {(inputs: Fc_Home_Hero_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FilmCraft editing Night of the Living Dead (1968, public domain) in the Effect Controls workspace.`)
};

/**
* | output |
* | --- |
* | "FilmCraft editing Night of the Living Dead (1968, public domain) in the Effect Controls workspace." |
*
* @param {Fc_Home_Hero_CaptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_hero_caption = /** @type {((inputs?: Fc_Home_Hero_CaptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Hero_CaptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_hero_caption(inputs)
});
export { fc_home_hero_caption as "fc.home.hero.caption" }